import { queryOptions, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { apiKeyQueryKeys, APIKeys } from '#api';
import { makeMaxResourceQueryFn } from '#util/api.ts';

export const maxAPIKeysQueryOptions = queryOptions({
  queryKey: apiKeyQueryKeys.maxList,
  queryFn: makeMaxResourceQueryFn(APIKeys.getAPIKeys),
});

export function useSuspenseMaxAPIKeysQuery() {
  return useSuspenseQuery(maxAPIKeysQueryOptions);
}

export function useSuspenseAPIKeyQuery(apiKeyID: string) {
  const queryClient = useQueryClient();

  return useSuspenseQuery({
    queryKey: apiKeyQueryKeys.detail(apiKeyID),
    queryFn: ({ signal }) => APIKeys.getAPIKey(apiKeyID, { signal }),
    // Use an api key details from the api keys list query as the initial data, if possible
    initialData: () => {
      const apiKeyQueryResults = queryClient.getQueryData(maxAPIKeysQueryOptions.queryKey)?.data ?? [];
      const apiKey = apiKeyQueryResults.find((d) => {
        return d.id === apiKeyID;
      });

      // If we found a match, use it as the initial data for the query
      if (apiKey) {
        return { data: apiKey };
      }
    },
    initialDataUpdatedAt: () => queryClient.getQueryState(maxAPIKeysQueryOptions.queryKey)?.dataUpdatedAt,
  });
}
